'use client';
import React from 'react';
import Link from 'next/link';
import { usePathname } from 'next/navigation';
import { LayoutDashboard, FileText, ShieldCheck, Mail, BarChart2 } from 'lucide-react';
import Icon from '@/components/ui/AppIcon';


const tabs = [
  { href: '/', label: 'Home', icon: LayoutDashboard },
  { href: '/invoice-capture-management', label: 'Invoices', icon: FileText },
  { href: '/warranty-locker', label: 'Warranty', icon: ShieldCheck },
  { href: '/mailbox', label: 'Mailbox', icon: Mail, badge: true },
  { href: '/analytics', label: 'Analytics', icon: BarChart2 },
];

export default function MobileBottomNav() {
  const pathname = usePathname();

  const isActive = (href: string) => {
    if (href === '/') return pathname === '/';
    return pathname.startsWith(href);
  };

  return (
    <nav className="lg:hidden fixed bottom-0 left-0 right-0 z-30 bg-card border-t border-border bottom-safe">
      <div className="flex items-center justify-around px-2 py-2">
        {tabs.map((tab) => {
          const active = isActive(tab.href);
          const Icon = tab.icon;
          return (
            <Link
              key={`btab-${tab.href}`}
              href={tab.href}
              className={`relative flex flex-col items-center gap-0.5 px-3 py-1.5 rounded-xl transition-all duration-150 ${active ? 'text-primary' : 'text-muted-foreground'}`}
            >
              {active && (
                <span className="absolute inset-0 bg-primary/10 border border-primary/20 rounded-xl" />
              )}
              <Icon size={20} className="relative z-10" />
              <span className="relative z-10 text-[10px] font-500">{tab.label}</span>
              {tab.badge && (
                <span className="absolute top-1 right-2 w-2 h-2 bg-primary rounded-full" />
              )}
            </Link>
          );
        })}
      </div>
    </nav>
  );
}